import { render, staticRenderFns } from "./SVGSpeechBalloon.vue?vue&type=template&id=e071c324&"
import script from "./SVGSpeechBalloon.vue?vue&type=script&lang=js&"
export * from "./SVGSpeechBalloon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e071c324')) {
      api.createRecord('e071c324', component.options)
    } else {
      api.reload('e071c324', component.options)
    }
    module.hot.accept("./SVGSpeechBalloon.vue?vue&type=template&id=e071c324&", function () {
      api.rerender('e071c324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/SVGSpeechBalloon.vue"
export default component.exports